var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 4.79981C0.799805 2.59067 2.59067 0.799805 4.7998 0.799805H16.3998C18.6089 0.799805 20.3998 2.59067 20.3998 4.7998V16.3998C20.3998 18.6089 18.6089 20.3998 16.3998 20.3998H4.79981C2.59067 20.3998 0.799805 18.6089 0.799805 16.3998V4.79981Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5004_41191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 13,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.2998,
    y: 6.7998,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5004_41191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4586 16.2628C13.5821 16.2545 13.6863 16.208 13.7713 16.1234C13.8562 16.0388 13.8987 15.9367 13.8987 15.8172C13.8987 15.6864 13.853 15.5774 13.7616 15.4901C13.6701 15.4027 13.5566 15.3632 13.4211 15.3716C13.0511 15.3966 12.705 15.3051 12.3829 15.0973C12.0609 14.8896 11.8522 14.5442 11.7569 14.0612C11.7403 13.9601 11.6918 13.8733 11.6116 13.8009C11.5312 13.7284 11.4311 13.6922 11.3112 13.6922C11.1719 13.6922 11.0574 13.743 10.9678 13.8447C10.8783 13.9463 10.8484 14.0648 10.8781 14.2003C11.0197 14.9634 11.3523 15.5063 11.8757 15.8289C12.3992 16.1515 12.9268 16.2961 13.4586 16.2628ZM13.2998 18.0384C12.0896 18.0384 11.0803 17.6238 10.2721 16.7946C9.46374 15.9653 9.05957 14.9332 9.05957 13.6982C9.05957 12.8272 9.40965 11.8773 10.1098 10.8487C10.8101 9.8201 11.8734 8.69964 13.2998 7.4873C14.7262 8.69964 15.7896 9.8201 16.4898 10.8487C17.19 11.8773 17.5401 12.8272 17.5401 13.6982C17.5401 14.9332 17.1359 15.9653 16.3276 16.7946C15.5193 17.6238 14.5101 18.0384 13.2998 18.0384ZM13.3008 16.7134C14.1432 16.7134 14.8396 16.4277 15.3898 15.8563C15.94 15.2848 16.2151 14.5654 16.2151 13.6982C16.2151 13.1228 15.9724 12.4648 15.4871 11.7241C15.0017 10.9832 14.2727 10.1586 13.2998 9.2503C12.327 10.1586 11.5979 10.9832 11.1126 11.7241C10.6272 12.4648 10.3846 13.1228 10.3846 13.6982C10.3846 14.5654 10.66 15.2848 11.2108 15.8563C11.7617 16.4277 12.4583 16.7134 13.3008 16.7134Z",
    fill: "#9DA4AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoBlack);
export default __webpack_public_path__ + "static/media/eco_black.fe3f447ce877e2c797f01dbee86158ed.svg";
export { ForwardRef as ReactComponent };